// extracted by mini-css-extract-plugin
export default {"sidebar-wrapper":"sidebar-wrapper--mp-zVKtN","sidebarWrapper":"sidebar-wrapper--mp-zVKtN"};